import $ from "jquery";
import counterUp from 'counterup2';
import Utils from "../helpers/utils";

class Counter {
    constructor() {
        this.element = '.countdown-number';
        this.bindCountDown();
        this.isDone = false;
    }

    bindCountDown() {

        $(document).ready(() => {
            $(window).scroll(() => {
                this.scroll();
            });

            this.scroll();
        });


    }

    scroll() {
        if (Utils.isElementInView($(this.element)) && !this.isDone) {
            [...document.querySelectorAll(this.element)].map((element) => {
                counterUp(element, {
                    duration: 1000,
                    delay: 16,
                })
            });

            this.isDone = true;
        }
    }
}

export default new Counter();
